import { Matrix } from '../../../platform/geom/Matrix';
import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';
import { Colors } from '../../../ui';
import { TextAlignment, TextSettings } from '../../canvas/entities/TextConventions';
import { TextUIField } from '../../canvas/entities/UIField';
import { BridgingTextFieldEditor } from '../../canvas/workspace/adapters/BridgingTextFieldEditor';
import { Spinner } from './Spinner';
import { SpinnerItem } from './SpinnerItem';
import { SpinnerSegmentDims } from './SpinnerLayout';

const settings = TextSettings.from({
    fontFamily: 'Rubik',
    fontColor: Colors.text,
    fontWeight: 500,
    fontSize: 0,
    lineHeight: 1.25,
    textMargin: 0,
    fontStyle: 'normal',
    maxFontSize: null,
    textAlignH: TextAlignment.middle,
    textAlignV: TextAlignment.middle,
});

const boundsFromOutline = ({ field }: SpinnerSegmentDims) => {

    const xy = field[0];
    const wv = Point.vector(field[0], field[1]);
    const hv = Point.vector(field[1], field[2]);

    return {
        bounds: new Rect(xy.x, xy.y, wv.length(), hv.length()),
        offset: Matrix.rotate(wv.angle()),
    };
};

const factory = (owner: Spinner, item: SpinnerItem, index: number): TextUIField => {
    const base = {
        ...boundsFromOutline(owner.layout.segments.applied[index]),
        ui: BridgingTextFieldEditor,
        owner: item,
        name: `item${index}`,
        settings,
        maxLength: null,
        value: null as string,
    };
    Object.defineProperty(base, 'value', {
        get: () => item.text,
        set: (value: string) => item.text = value,
    });
    return base;
};

export const SpinnerItemField = Object.assign(factory, { boundsFromOutline });
